import * as actions from '../actions/problem.action';
import {OPEN_STATUS_OPEN} from './ui.reducer.js';
import {default_state} from './index.js';
import {ACCOUNT_FLAGGED} from '../modules/apiWrapper.js';

export function problem(state=default_state.problem, action={}){
    let problem = action.problem || {};
    let steps   = action.steps || [];
    let comments = action.comments ? [...action.comments] : action.comments;
    let reviews = action.reviews || [];
    let new_comment = action.new_comment || {};
    let open_status = action.all_steps_open_status;
    let access_restriction = action.access_restriction;
    let pageTitle = action.pageTitle;
    let problemHtml = action.problemHtml || '';

    let default_problem = default_state.problem;
    let comment_list = [];
    var opened_solutions;
    var opened_comments;

    function openAll(steps=state.steps) {
        var opened_sols = {};
        steps.forEach(function (step) {
            opened_sols[step.id] = true;
        });
        return opened_sols;
    }

    function closeAllButOne(steps=state.steps) {
        var opened_sols = {};
        steps.forEach(function (step, i) {
            opened_sols[step.id] = (i == 0);
        });
        return opened_sols;
    }

    switch (action.type) {
        case actions.OPEN_PROBLEM:
            return {
                ...default_problem,
                identifier: action.identifier,
                problem_exists: true
            };

        case actions.PROBLEM_OPENED:
            return {
                ...state,
                ...problem
            };

        case actions.SOLUTIONS_DOWNLOADED:
            let first_step = steps[0];

            if (open_status == OPEN_STATUS_OPEN) {
                opened_solutions = openAll(steps);
            } else {
                opened_solutions = closeAllButOne(steps);
            }

            let total_steps = action.total_steps || state.total_steps;

            return {
                ...state,
                steps : [...steps],
                total_steps : total_steps,
                comments,
                reviews : reviews,
                solution_id : action.solution_id,
                hasSolution : !!(steps && steps[0]) || !!total_steps,
                opened_solutions,
                access_restriction,
                pageTitle,
                problemHtml
            };

        case actions.OPEN_ALL_SOLUTIONS:
            opened_solutions = openAll();

            return {
                ...state,
                opened_solutions: opened_solutions
            };

        case actions.CLOSE_ALL_SOLUTIONS:
            opened_solutions = closeAllButOne();

            return {
                ...state,
                opened_solutions: opened_solutions
            };

        case actions.TOGGLE_SOLUTION:
            opened_solutions = state.opened_solutions;

            return {
                ...state,
                opened_solutions: {
                    ...opened_solutions,
                    [action.id]: !opened_solutions[action.id]
                }
            };

        case actions.NO_PROBLEM:
            return {
                ...default_problem,
                problem_exists: false,
                identifier: action.identifier
            };

        case actions.TOGGLE_COMMENTS:
            opened_comments = state.opened_comments;

            return {
                ...state,
                opened_comments: {
                    ...opened_comments,
                    [action.id]: !opened_comments[action.id]
                }
            };

        case actions.POST_COMMENT:
            comment_list = [];
            new_comment.is_posting = true;
            state.comments.forEach(function (comment) {
                comment_list.push({
                    ...comment
                });
            });
            comment_list.push(new_comment);
            return {
                ...state,
                comments: comment_list
            };

        case actions.COMMENT_POSTED:
            comment_list = [];
            state.comments.forEach(function (comment) {
                if (comment.commentId == new_comment.commentId || comment.is_posting) {
                    comment = {
                        ...comment,
                        commentId: new_comment.commentId,
                        is_posting: false
                    };
                }
                comment_list.push({
                    ...comment
                });
            });
            return {
                ...state,
                comments: comment_list
            };

        case actions.POST_COMMENT_ERROR:
            comment_list = [];
            state.comments.forEach(function (comment) {
                if (!comment.is_posting) {
                    comment_list.push({
                        ...comment
                    })
                }
            });
            return {
                ...state,
                comments: comment_list
            };

        case actions.REMOVE_COMMENT:
            comment_list = [];
            state.comments.forEach(function (comment) {
                let newComment = {
                    ...comment
                };
                if (comment.commentId == action.comment_id) {
                    newComment.is_deleting = true
                }
                comment_list.push({
                    ...newComment
                });
            });
            return {
                ...state,
                comments: comment_list
            };

        case actions.COMMENT_REMOVED:
            comment_list = [];
            state.comments.forEach(function (comment) {
                if (action.comment_id != comment.commentId) {
                    comment_list.push({
                        ...comment
                    });
                }
            });
            return {
                ...state,
                comments: comment_list
            };

        case actions.REMOVE_COMMENT_ERROR:
            comment_list = [];
            state.comments.forEach(function (comment) {
                let newComment = {
                    ...comment,
                    is_deleting: false
                };
                comment_list.push({
                    ...newComment
                })
            });
            return {
                ...state,
                comments: comment_list
            };

        case actions.NO_ACCESS:
            return {
                ...state,
                has_access :false
            };

        case actions.ACCOUNT_FLAGGED:
            return {
                ...state,
                access_restriction : ACCOUNT_FLAGGED
            };

        case actions.LIMIT_EXCEEDED:
            return {
                ...default_problem,
                limit_exceeded : true
            }

        case actions.UNKNOWN_ERROR:
            return {
                ...state,
                unknown_error : action.error
            }
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/problem.reducer.js